import { createNotification } from 'react-redux-notify';
import { select, put, takeLatest, all } from 'redux-saga/effects';

import api from '../../Environment';
import { getErrorNotificationMessage } from '../../components/helper/NotificationMessage';
import {
  searchUserPostFailure,
  fetchSingleUserPostsFailure,
  fetchSingleUserPostsSuccess,
  fetchSingleUserProfileFailure,
  fetchSingleUserProfileSuccess,
  fetchSingleUserProfileStart,
  fetchSingleUserPublicProfileStart,
  fetchSingleUserPublicPostsStart,
  fetchSingleUserPostsStart,
} from '../actions/OtherUserAction';
import {
  FETCH_SINGLE_USER_CONTENT_START,
  FETCH_SINGLE_USER_POSTS_START,
  FETCH_SINGLE_USER_PROFILE_START,
  FETCH_SINGLE_USER_PUBLIC_POSTS_START,
  FETCH_SINGLE_USER_PUBLIC_PROFILE_START,
  SEARCH_USER_POST_START,
} from '../actions/ActionConstant';
import { showErrorComponent } from '../actions/ComponentAction';
import { isSubscribedToStart, fetchPerformerSubscriptionPlanStart } from '../actions/SubscriptionPaymentAction';
import { fetchUserShowcaseStartById } from '../actions/ShowcaseAction';

function* fetchOtherUserContent(action) {
  try {
    const { userDetails, postDetails } = action.data
    let response = yield api.postMethod('is_valid_authorization_token', {});
    if (!response.data.success) {
      yield put(fetchSingleUserPublicProfileStart(userDetails));
      if(postDetails){
        yield put(fetchSingleUserPublicPostsStart(postDetails));
      }
    } else {
      yield put(fetchSingleUserProfileStart(userDetails));
      if(postDetails){ 
        yield put(fetchSingleUserPostsStart(postDetails));
      }
    }
  } catch (error) {
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
  }
}

function* fetchOtherUserProfileAPI() {
  try {
    const inputData = yield select((state) => state.otherUser.userDetails.inputData);
    const response = yield api.postMethod('other_profile', inputData);
    if (response.data.success) {
      const payload = response.data.data
      yield put(fetchSingleUserProfileSuccess(payload));
      if (payload?.user?.unique_id) {
        yield put(isSubscribedToStart(payload.user.unique_id));
        yield put(fetchUserShowcaseStartById(response.data.data?.user?.id));
        yield put(fetchPerformerSubscriptionPlanStart(payload.user.unique_id));
      }
    } else {
      yield put(fetchSingleUserProfileFailure(response.data.error));
      if (response.data.error_code !== 135) {
        const notificationMessage = getErrorNotificationMessage(response.data.error);
        yield put(createNotification(notificationMessage));
      }
    }
  } catch (error) {
    yield put(fetchSingleUserProfileFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchOtherUserPublicProfileAPI() {
  try {
    const inputData = yield select((state) => state.otherUser.userDetails.inputData);
    const response = yield api.postMethod('public_profile', inputData);
    if (response.data.success) {
      yield put(fetchUserShowcaseStartById(response.data.data?.user?.id));
      yield put(fetchSingleUserProfileSuccess(response.data.data));
    } else {
      yield put(fetchSingleUserProfileFailure(response.data.error));
      if (response.data.error_code !== 135) {
        const notificationMessage = getErrorNotificationMessage(response.data.error);
        yield put(createNotification(notificationMessage));
      }
    }
  } catch (error) {
    yield put(fetchSingleUserProfileFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchOtherUserPostAPI() {
  try {
    const inputData = yield select((state) => state.otherUser.userPosts.inputData);
    const response = yield api.postMethod('other_profile_posts', inputData);
    if (response.data.success) {
      yield put(fetchSingleUserPostsSuccess(response.data.data));
    } else {
      yield put(fetchSingleUserPostsFailure(response.data.error));
      if (response.data.error_code !== 135) {
        const notificationMessage = getErrorNotificationMessage(response.data.error);
        yield put(createNotification(notificationMessage));
      }
    }
  } catch (error) {
    yield put(fetchSingleUserPostsFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchOtherUserPublicPostAPI() {
  try {
    const inputData = yield select((state) => state.otherUser.userPosts.inputData);
    const response = yield api.postMethod('public_profile_posts', inputData);
    if (response.data.success) {
      yield put(fetchSingleUserPostsSuccess(response.data.data));
    } else {
      yield put(fetchSingleUserPostsFailure(response.data.error));
      if (response.data.error_code !== 135) {
        const notificationMessage = getErrorNotificationMessage(response.data.error);
        yield put(createNotification(notificationMessage));
      }
    }
  } catch (error) {
    yield put(fetchSingleUserPostsFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* searchPostAPI() {
  try {
    const inputData = yield select((state) => state.otherUser.searchPosts.inputData);
    const response = yield api.postMethod('posts_search', inputData);
    if (response.data.success) {
      yield put(fetchSingleUserPostsSuccess(response.data.data));
    } else {
      yield put(searchUserPostFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(response.data.error);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(searchUserPostFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

export default function* pageSaga() {
  yield all([yield takeLatest(FETCH_SINGLE_USER_POSTS_START, fetchOtherUserPostAPI)]);
  yield all([yield takeLatest(FETCH_SINGLE_USER_PROFILE_START, fetchOtherUserProfileAPI)]);
  yield all([yield takeLatest(FETCH_SINGLE_USER_PUBLIC_POSTS_START, fetchOtherUserPublicPostAPI)]);
  yield all([yield takeLatest(FETCH_SINGLE_USER_PUBLIC_PROFILE_START, fetchOtherUserPublicProfileAPI)]);

  yield all([yield takeLatest(SEARCH_USER_POST_START, searchPostAPI)]);
  yield all([yield takeLatest(FETCH_SINGLE_USER_CONTENT_START, fetchOtherUserContent)]);
}
